const loginValidation = () => {
    document.addEventListener("DOMContentLoaded", () => {
        const form = document.querySelector('.woocommerce-form-login');
        if (!form) return;

        const rc_form_login = document.getElementById('rc_form_login');
        const response_true = document.getElementById('wpcf7-response-output');
        if (!rc_form_login) return;

        const usernameInput = form.querySelector('#username');
        const passwordInput = form.querySelector('#password');
        const submitBtn = form.querySelector('button[type="submit"]');
        const loader = form.querySelector('.wc-loader');

        let serverErrorContainer = form.querySelector('.server-error-container');
        if (!serverErrorContainer) {
            serverErrorContainer = document.createElement('div');
            serverErrorContainer.className = 'server-error-container';
            serverErrorContainer.style.color = 'red';
            serverErrorContainer.style.fontSize = '0.9em';
            serverErrorContainer.style.marginBottom = '10px';
            submitBtn.parentNode.parentNode.insertBefore(serverErrorContainer, submitBtn.parentNode);
        }

        const showInputError = (input, message) => {
            let errorEl = input.nextElementSibling;
            if (errorEl && errorEl.classList.contains('input-error')) {
                errorEl.remove();
            }

            input.classList.remove('wpcf7-not-valid');

            if (message) {
                const div = document.createElement('div');
                div.className = 'input-error';
                div.style.color = 'red';
                div.style.fontSize = '0.9em';
                div.textContent = message;
                input.parentNode.insertBefore(div, input.nextSibling);
                input.classList.add('wpcf7-not-valid');
            }
        };

        const showServerError = (message) => {
            serverErrorContainer.innerHTML = '';
            if (message) {
                const div = document.createElement('div');
                div.innerHTML = message;
                serverErrorContainer.appendChild(div);
            }
        };

        const isValidEmail = (email) => {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(email);
        };

        [usernameInput, passwordInput].forEach(input => {
            input.addEventListener('input', () => {
                input.classList.remove('wpcf7-not-valid');
                const errorEl = input.nextElementSibling;
                if (errorEl && errorEl.classList.contains('input-error')) {
                    errorEl.remove();
                }
            });
        });

        form.addEventListener('submit', (e) => {
            e.preventDefault();

            let hasError = false;

            if (!usernameInput.value.trim()) {
                showInputError(usernameInput, rcTranslate.enterEmail);
                hasError = true;
            } else if (!isValidEmail(usernameInput.value.trim())) {
                showInputError(usernameInput, rcTranslate.invalidEmail || rcTranslate.validEmail);
                hasError = true;
            } else {
                showInputError(usernameInput, '');
            }

            if (!passwordInput.value.trim()) {
                showInputError(passwordInput, rcTranslate.enterPassword);
                hasError = true;
            } else {
                showInputError(passwordInput, '');
            }

            if (hasError) return;

            showServerError('');

            const data = new FormData();
            data.append('action', 'ajaxLoginHandler');
            data.append('username', usernameInput.value.trim());
            data.append('password', passwordInput.value.trim());
            data.append('remember', form.querySelector('#rememberme').checked ? 'forever' : '');
            data.append('nonce', rcData.nonce);

            submitBtn.disabled = true;
            if (loader) loader.style.display = 'block';

            fetch(rcData.ajaxUrl, {
                method: 'POST',
                body: data,
            })
                .then(response => response.json())
                .then(json => {
                    if (json.success) {
                        response_true.style.display = 'block';
                        window.location.href = json.data.redirect;
                    } else {
                        showServerError(`${json.data.message}`);
                    }
                })
                .catch(err => console.error(err))
                .finally(() => {
                    submitBtn.disabled = false;
                    if (loader) loader.style.display = 'none';
                });
        });
    });
};

export default loginValidation;
